import { mapState } from 'vuex';
import { isNullOrEmpty } from '../../../../../utils/vuex';
export default {
  name: 'CoreDtwinStateBridgeIncomingwebhook',
  props: {
    // the current edited binding
    lclModel: {
      type: Object,
      required: true
    },
    // is this an 'edit', 'create', or mass-variable- 'import'?
    mode: {
      type: String,
      required: false,
      default: () => 'edit'
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      deviceIdentifier: null,
      parsedPacketVariable: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    formIsValid() {
      if (this.templateContext) {
        return true;
      }
      return !isNullOrEmpty(this.deviceIdentifier);
    }
  },
  watch: {
    parsedPacketVariable() {
      this.emitSelection();
    },
    deviceIdentifier() {
      this.emitSelection();
    }
  },
  created() {
    if (this.mode !== 'create' && this.mode !== 'import') {
      this.deviceIdentifier = this.lclModel.properties.binding.options.identifier;
      this.parsedPacketVariable = this.lclModel.properties.binding.options.variable;
    }
  },
  methods: {
    emitSelection() {
      this.$emit('bridge-binding-changed', {
        variable: this.parsedPacketVariable
      });
    },
    saveState() {
      this.lclModel.properties.binding.options.identifier = this.deviceIdentifier;
      this.lclModel.properties.binding.options.variable = this.parsedPacketVariable;
    }
  }
};